import axios from 'axios'
import wrappers from '../utils/wrappers'
import type { WritingHabitsBatchPayload } from '@/types/writing-habits'

const url = `${import.meta.env.VITE_API_URL}/v1/writing-habits`

export default {
  sendBatch(payload: WritingHabitsBatchPayload) {
    return axios
      .post(
        `${url}/batch`,
        {
          terms: payload.terms,
          words: payload.words,
          clientBatchId: payload.clientBatchId,
        },
        {
          timeout: 10000,
          action: 'writingHabits.sendBatch',
        },
      )
      .then((response: any) => {
        if (response?.status === 204) {
          return undefined
        }
        return wrappers.handleEscribonautaResponse(response)
      })
  },

  sendBatchKeepalive(payload: WritingHabitsBatchPayload) {
    const token = typeof localStorage === 'undefined' ? '' : localStorage.getItem('accessToken')
    if (!token) return Promise.resolve(false)
    return fetch(`${url}/batch`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        terms: payload.terms,
        words: payload.words,
        clientBatchId: payload.clientBatchId,
      }),
      keepalive: true,
    }).then((response) => {
      if (response.status === 204 || (response.status >= 200 && response.status < 300)) {
        return true
      }
      if (response.status >= 400 && response.status < 500 && response.status !== 408 && response.status !== 429) {
        return true
      }
      return false
    })
  },

  feedback() {
    return axios
      .get(`${url}/feedback`, {
        timeout: 10000,
        action: 'writingHabits.feedback',
      })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },
}
